import React, {useEffect, useRef, useState} from "react";
import {Row, Col, Space, Button, message} from "antd";
import "./MedicineSearchItem.scss";
import {convertTimeSignatureToMins, formatDateToString} from "helper/common";
import {FORMAT_TIME} from "types/enums";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import moment from "moment";
import {nurseOutService} from "api";
import {renderViTriMat} from "helper/nurseOut";
import {
  getListLichsuTraThuocAPI,
  setCallApiList,
  setDetailPhieu,
  setStatusTraThuoc,
} from "redux/reducer/nurseOut";
import Notification from "components/common/notification/notification";
const MedicineSearchItem = props => {
  const idPhieuDieuDuong = useAppSelector(state => state.nurseOut.idPhieu);
  const allListThuocTraMat = useAppSelector(
    state => state.nurseOut.allListThuocTraMat
  );
  const dispatch = useAppDispatch();
  const detailPhieu = useAppSelector(state => state.nurseOut.detailPhieu);
  const {data} = props;
  const [thuocTra, setThuocTra] = useState<any>();
  const [isStopStatus, setIsStopStatus] = useState(false);
  const [hourRealtime, setHourRealtime] = useState(0);
  const [secRealtime, setSecRealtime] = useState(0);
  const [minRealtime, setMinRealtime] = useState(0);
  let interval = useRef<any>();
  const {
    thoiGianTraThuoc,
    nguoiTra,
    isStop,
    ghiChu,
    viTriMat,
    loaiThuoc,
    bacSi,
    id,
  } = data;

  useEffect(() => {
    const {hour, min, second} = convertTimeSignatureToMins(
      moment().format(),

      moment(thoiGianTraThuoc).format()
    );
    setHourRealtime(hour);
    setMinRealtime(min);
    setSecRealtime(second);
  }, []);
  useEffect(() => {
    clearInterval(interval.current);
    interval.current = setInterval(() => {
      const {hour, min, second} = convertTimeSignatureToMins(
        moment().format(),

        moment(thoiGianTraThuoc).format()
      );
      setHourRealtime(hour);
      setMinRealtime(min);
      setSecRealtime(second);
    }, 1000);
  }, [data]);
  useEffect(() => {
    getThuocTra();
  }, [allListThuocTraMat, data]);
  useEffect(() => {
    setIsStopStatus(isStop);
  }, [data]);
  useEffect(() => {
    if (hourRealtime * 60 == thuocTra?.thoiGianDem && !isStopStatus) {
      stop();
    }
    if (isStopStatus) {
      clearInterval(interval.current);
      interval.current = null;
    }
  }, [hourRealtime, isStopStatus]);
  useEffect(() => {
    if (isStopStatus == false) {
      // const updateDetailPhieu = {...detailPhieu, traThuoc: 1};
      dispatch(setStatusTraThuoc(1));
    }
  }, [isStopStatus]);
  const getThuocTra = () => {
    var value = allListThuocTraMat.find(
      (e, index) => e.tenVietTat == loaiThuoc
    );
    setThuocTra(value);
  };
  const stop = () => {
    clearInterval(interval.current);
    interval.current = null;
    traThuoc();
    // const updateDetailPhieu = {...detailPhieu, traThuoc: 2};
    // // dispatch(setDetailPhieu(updateDetailPhieu));
    dispatch(setStatusTraThuoc(2));
    dispatch(setCallApiList(true));
  };
  const traThuoc = async () => {
    const data = {
      id: id,
      idPhieuDieuDuong: idPhieuDieuDuong,
      thoiGianTraThuoc: moment().toISOString(),
      loaiThuoc: loaiThuoc,
      viTriMat: viTriMat,
      nguoiTra: nguoiTra,
      bacSi: bacSi,
      ghiChu: ghiChu,
      isStop: true,
    };
    try {
      const res = await nurseOutService.stopTraThuoc(id, data);
      Notification("success", "Cập nhật tra thuốc thành công");
      dispatch(getListLichsuTraThuocAPI(idPhieuDieuDuong));
      dispatch(setCallApiList(true));
      setIsStopStatus(true);
    } catch (error) {
      Notification("error", "Đã có lỗi khi dừng tra thuốc");
    }
  };

  return (
    <div className="medicine-search-item">
      <Row justify={"space-between"}>
        <Col xs={12} md={12} lg={4} xl={4}>
          <span>
            {formatDateToString(thoiGianTraThuoc, FORMAT_TIME.dateTime)}
          </span>
        </Col>
        <Col xs={12} md={12} lg={4} xl={4}>
          BS chỉ định <span>{bacSi}</span>
        </Col>
        <Col xs={12} md={12} lg={4} xl={4}>
          Người tra <span>{nguoiTra}</span>
        </Col>
        <Col xs={12} md={12} lg={4} xl={4}>
          Vị trí mắt <span>{renderViTriMat(viTriMat)}</span>
        </Col>
        <Col xs={12} md={12} lg={4} xl={4}>
          {" "}
          Thuốc <span> {thuocTra?.tenVietTat}</span>
        </Col>
        <Col xs={12} md={12} lg={4} xl={4}>
          <Row>
            {!isStopStatus &&
              thuocTra?.thoiGianDem != 0 &&
              data?.idPhieuDieuDuong == idPhieuDieuDuong && (
                <>
                  <Col flex={"80px"}>
                    <Button danger type="primary" onClick={stop}>
                      Dừng
                    </Button>
                  </Col>{" "}
                  <Col>
                    {" "}
                    Timer{" "}
                    <span>{`${hourRealtime}:${minRealtime}:${secRealtime}`}</span>{" "}
                  </Col>
                </>
              )}
          </Row>
        </Col>
      </Row>
    </div>
  );
};
export default MedicineSearchItem;
